'use strict'
/* ================================
* Utils
* ================================ */
import { gsap } from "gsap";


/**
 * Convert a kebab-case string into a camelCase one
 * @param  {string} string The string to convert
 * @return {string}        The camelCased string
 */
export const camelCase = function(string) {
	return string.toLowerCase().replace(/-(.)/g, (match, group) => {
		return group.toUpperCase()
	})
}



/**
 * Convert a kebab-case string into a PascalCase one
 * @param  {string} string The string to convert
 * @return {string}        The transformed string
 */
export const pascalCase = function(string) {
	// Remove dashes and transform
	// following letter to uppercase
	string = string.toLowerCase()
		.replace(/-(.)/g, (match, group) => {
			return group.toUpperCase()
		})

	// Return string with first letter
	// transformed to uppercase
	return string.charAt(0).toUpperCase() + string.slice(1)
}



/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * @param  {number}    wait       Timer
 * @param  {boolean}   immediate  Launch the function immediately
 * @param  {function}  func       The function that needs debounce
 * @return {function}             A function to bind to the event debounced
 */
export const debounce = function(wait, immediate, func) {
	let timeout;

	return function() {
		const context = this;
		const args = arguments;
		const later = () => {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		let callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}



/**
 * Animate scroll for anchor links
 * @return {void}
 */
export const smoothScroll = function(event) {
	if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
		const $target = document.querySelectorAll(this.hash)
		if ($target.length) {
			let pos = $target.getBoundingClientRect();
			gsap.to(
				document.querySelectorAll('html, body'),
				{
					duration: 0.8,
					scrollTop: window.scrollY + pos.top,
					ease: "expo.inOut"
				}
			)
			return false
		}
	}
}




/**
 * Convert degrees to rad
 * @param  {integer} degrees The angle to convert
 * @return {integer}         The converted angle in rad
 */
export const degToRad = (degrees) => {
	return degrees * Math.PI / 180
}



/**
 * Get a random integer in the given interval
 * @param  {integer} min The interval's minimum
 * @param  {integer} max The interval's maximum
 * @return {integer}     A random integer in the given interval
 */
export const getRandomInt = (min, max) => {
	return Math.floor(Math.random() * (max - min)) + min
}

/**
 * Get the URL parameters
 * source: https://css-tricks.com/snippets/javascript/get-url-variables/
 * @param  {String} url The URL
 * @return {Object}     The URL parameters
 */
export const getParams = (url) => {
	var params = {};
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	if( query == '') return;
	
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};

// Explicitly save/update a url parameter using HTML5's replaceState().
export const updateQueryStringParam = (key, value) => {
  let baseUrl = [location.protocol, '//', location.host, location.pathname].join('');
  let urlQueryString = document.location.search;
  var newParam = key + '=' + value,
	params = '?' + newParam;
	
	if( value == '' ) {
		if(urlQueryString.indexOf(key) >= 0 ) {
			params = urlQueryString.substring(0, urlQueryString.indexOf(key) - 1)
		}
	} else {

		// If the "search" string exists, then build params from it
		if (urlQueryString) {
			let keyRegex = new RegExp('([\?&])' + key + '[^&]*');
			// If param exists already, update it
			if (urlQueryString.match(keyRegex) !== null) {
				params = urlQueryString.replace(keyRegex, "$1" + newParam);
			} else { // Otherwise, add it to end of query string
				params = urlQueryString + '&' + newParam;
			}
		}

	}
  window.history.replaceState({}, "", baseUrl + params);
}